import { render, staticRenderFns } from "./BookingPtpSelect.vue?vue&type=template&id=fdb5296e"
import script from "./BookingPtpSelect.vue?vue&type=script&lang=ts"
export * from "./BookingPtpSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports